class GiftMembership extends HTMLElement {
  constructor() {
    super();
    this.closeModal = this.closeModal.bind(this);
    this.tryCloseModal = this.tryCloseModal.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this._onOverlayClick = this._onOverlayClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    this.noClose = false;
  }

  connectedCallback() {
    this.overlay = this.querySelector('.gift-membership-modal__overlay');
    this.closeBtn = this.querySelector('.gift-membership-modal__close');
    this.submitBtn = this.querySelector('.gift-membership-submit-btn');
    this.content = this.querySelector('.gift-membership-modal__content');
    this.cancelBtn = this.querySelector('.gift-membership-cancel-btn');
    if (this.cancelBtn) this.cancelBtn.addEventListener('click', this.cancelGift.bind(this));


    this.initDateField();

    const cartHasGift = this.dataset.cartHasGift === 'true';
    const filled = this.dataset.hasFillGiftInformation === 'filled';
    if (cartHasGift && !filled) {
      this.openModal();
      this.setNoClose(true);
    }

    if (this.overlay) this.overlay.addEventListener('click', this._onOverlayClick);
    if (this.closeBtn) this.closeBtn.addEventListener('click', (e) => { e.preventDefault(); this.tryCloseModal(); });
    if (this.submitBtn) this.submitBtn.addEventListener('click', this.submitForm);

    document.addEventListener('keydown', this._onKeyDown);

    this.__gm_initialized = true;
  }

  disconnectedCallback() {
    if (this.overlay) this.overlay.removeEventListener('click', this._onOverlayClick);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this.closeModal);
    if (this.submitBtn) this.submitBtn.removeEventListener('click', this.submitForm);
    document.removeEventListener('keydown', this._onKeyDown);
    this.__gm_initialized = false;
  }
  async cancelGift() {
    this.showLoading();

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();

      const giftItem = cart.items.find(item =>
        item.product_type === 'Gift Membership' ||
        (item.product_type && item.product_type.toLowerCase().includes('gift'))
      );

      if (!giftItem) {
        this.hideLoading();
        this.closeModal();
        return;
      }

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0
        })
      });
      var event = new CustomEvent("cart:updated", { bubbles: true });
      document.dispatchEvent(event);
      Shopify.theme.jsAjaxCart.updateView();
      this.hideLoading();
      this.setNoClose(false);
      this.closeModal();

    } catch (err) {
      this.hideLoading();
      this.showError(this.cancelBtn || this, 'Unable to remove the gift item. Please try again.');
    }
  }


  _onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (this.noClose) {
        e.preventDefault();
        e.stopPropagation();
        this._flashCannotClose();
      } else {
        this.tryCloseModal();
      }
    }
  }

  _onOverlayClick(e) {
    if (e.target === this.overlay) {
      this.tryCloseModal();
    }
  }

  setNoClose(value) {
    this.noClose = !!value;
    if (this.noClose) {
      this.classList.add('gift-no-close');
    } else {
      this.classList.remove('gift-no-close');
    }
  }

  tryCloseModal() {
    if (this.noClose) {
      this._flashCannotClose();
      this.showError(this.submitBtn || this, this.dataset.messageCompleteForm || 'Please complete gift details before closing.');
      return;
    }
    this.closeModal();
  }

  _flashCannotClose() {
    if (!this.content) return;
    this.content.classList.add('shake');
    setTimeout(() => this.content.classList.remove('shake'), 420);
  }

  initDateField() {
    const dateInput = this.querySelector('#gift_membership-date');
    if (!dateInput) return;
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    if (!dateInput.value) dateInput.value = `${yyyy}-${mm}-${dd}`;
  }

  async openModal() {
    this.classList.add('active');
    document.documentElement.classList.add('body-with-gift-membership-modal-open');

    await this.checkGiftInCart();
  }

  async checkGiftInCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Cart fetch failed');
      const cart = await res.json();

      const hasGiftWithoutInfo = cart.items.some(item =>
        (item.product_type === 'Gift Membership' || (item.product_type && item.product_type.toLowerCase().includes('gift')))
        && !(item.properties && (item.properties.recipient_email))
      );

      if (hasGiftWithoutInfo) {
        this.setNoClose(true);
        this.dataset.hasFillGiftInformation = 'not-filled';
      } else {
        this.setNoClose(false);
        this.dataset.hasFillGiftInformation = 'filled';
      }
    } catch (err) {
    }
  }


  closeModal() {
    this.classList.remove('active');
    document.documentElement.classList.remove('body-with-gift-membership-modal-open');
    this.setNoClose(false);
  }

  showError(input, message) {
    if (!input || !input.parentElement) {
      const existing = this.querySelector('.gift-global-error');
      if (existing) existing.remove();
      const p = document.createElement('p');
      p.className = 'gift-global-error error-message';
      p.textContent = message;
      if (this.content) this.content.prepend(p);
      setTimeout(() => p.remove(), 5000);
      return;
    }
    const oldError = input.parentElement.querySelector('.error-message');
    if (oldError) oldError.remove();
    const error = document.createElement('p');
    error.className = 'error-message';
    error.textContent = message;
    input.parentElement.appendChild(error);
    setTimeout(() => error.remove(), 5000);
  }

  showSuccessMessage(message) {
    const existingMsg = this.querySelector('.gift-success-message');
    if (existingMsg) existingMsg.remove();
    const msg = document.createElement('p');
    msg.className = 'gift-success-message';
    msg.textContent = message;
    if (this.submitBtn) {
      this.submitBtn.insertAdjacentElement('afterend', msg);
      setTimeout(() => msg.remove(), 4000);
    } else if (this.content) {
      this.content.appendChild(msg);
      setTimeout(() => msg.remove(), 4000);
    }
  }

  showLoading() {
    if (this.loadingOverlay) return;
    this.loadingOverlay = document.createElement('div');
    this.loadingOverlay.className = 'gift-membership-loading';
    this.loadingOverlay.innerHTML = `<div class="spinner"></div>`;
    if (this.content) this.content.appendChild(this.loadingOverlay);
  }

  hideLoading() {
    if (this.loadingOverlay) {
      this.loadingOverlay.remove();
      this.loadingOverlay = null;
    }
  }

  async submitForm(e) {
    if (e && e.preventDefault) e.preventDefault();

    this.querySelectorAll('.error-message').forEach((el) => el.remove());

    const from = this.querySelector('#gift_membership-from');
    const to = this.querySelector('#gift_membership-to');
    const email = this.querySelector('#gift_membership-email');
    const date = this.querySelector('#gift_membership-date');
    const message = this.querySelector('#gift_membership-message');

    let hasError = false;
    const validateMsg = this.dataset.messageValidate || 'This field is required';
    const emailInvalidMsg = this.dataset.messageEmailInvalid || 'Invalid email format';

    if (!email || !email.value.trim()) { if (email) this.showError(email, validateMsg); hasError = true; }
    else if (!/^[^\s@]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email.value.trim())) { if (email) this.showError(email, emailInvalidMsg); hasError = true; }
    if (!date || !date.value.trim()) { if (date) this.showError(date, validateMsg); hasError = true; }

    if (hasError) {
      this._flashCannotClose();
      return;
    }

    this.showLoading();

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();

      const giftItem = cart.items.find(item =>
        (item.product_type === 'Gift Membership' || (item.product_type && item.product_type.toLowerCase().includes('gift')))
        && !(item.properties && (item.properties.recipient_email))
      ) || cart.items.find(item => (item.product_type === 'Gift Membership' || (item.product_type && item.product_type.toLowerCase().includes('gift'))));

      if (!giftItem) {
        console.warn('[GiftMembership] No gift item found in cart', cart.items);
        this.hideLoading();
        this.showError(this.submitBtn || this, this.dataset.messageGiftNotFound || 'Gift item not found in cart');
        return;
      }

      const normaliseText = (toClean) =>
        toClean
          .trim()
          .replace(/\r\n/g, '\n')
          .replace(/\r/g, '\n')
          .replace(/\n/g, '\\n');      

      const updateData = {
        id: giftItem.key,
        properties: {
          'gift_giver_name': from ? from.value.trim() : '',
          'recipient_name': to ? to.value.trim() : '',
          'recipient_email': email ? email.value.trim() : '',
          'gift_date': date ? date.value.trim() : '',
          'gift_message': message ? normaliseText(message.value) : '',
        },
      };

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(updateData),
      });

      this.hideLoading();

      if (response.ok) {
        this.dataset.hasFillGiftInformation = 'filled';
        this.setNoClose(false);

        this.showSuccessMessage(this.dataset.successMessage || 'Gift membership details saved successfully');
        setTimeout(() => this.closeModal(), 1400);
      } else {
        const text = await response.text().catch(() => 'non-json response');
        this.showError(this.submitBtn || this, this.dataset.messageSaveFailed || 'Failed to save gift details');
      }
    } catch (err) {
      this.hideLoading();
      this.showError(this.submitBtn || this, this.dataset.messageTryAgain || 'Something went wrong. Please try again.');
    }
  }
}

if (!customElements.get('gift-membership')) {
  customElements.define('gift-membership', GiftMembership);
}
